import { FC } from 'react'
import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'
import { useFormik } from 'formik'
import { gql, useMutation } from '@apollo/client'

type Props = {
  isOpen: boolean
  onClose: () => void
  appName: string
  defaultBranch: string
}

const DEPLOY_MUTATION = gql`
  mutation Deploy($appName: String!, $branch: String!) {
    deploy(appName: $appName, branch: $branch) {
      id
    }
  }
`

const ManualDeployModal: FC<Props> = ({
  isOpen,
  onClose,
  appName,
  defaultBranch,
}) => {
  const [deploy, { loading }] = useMutation(DEPLOY_MUTATION)

  const initialValues = {
    branch: defaultBranch,
  }
  const formik = useFormik({
    initialValues,
    validate: (values) => {
      const errors: Record<string, string> = {}
      if (!values.branch) {
        errors.branch = 'Required'
      }
      return errors
    },
    onSubmit: async (values) => {
      const variables = {
        appName,
        branch: values.branch,
      }
      await deploy({ variables })
      formik.resetForm()
      onClose()
    },
  })

  const isControlInvalid = (controlName: keyof typeof initialValues) =>
    !!(formik.errors[controlName] && formik.touched[controlName])

  return (
    <Modal
      isOpen={isOpen}
      size="2xl"
      isCentered
      onClose={() => {
        formik.resetForm()
        onClose()
      }}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Manual deploy</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <form onSubmit={formik.handleSubmit}>
            <FormControl
              id="branch"
              colorScheme="cyan"
              isRequired
              isInvalid={isControlInvalid('branch')}
            >
              <FormLabel htmlFor="branch">Branch</FormLabel>
              <Input
                type="text"
                id="branch"
                name="branch"
                onChange={formik.handleChange}
                value={formik.values.branch}
                placeholder="main"
              />
              <FormErrorMessage>{formik.errors.branch}</FormErrorMessage>
            </FormControl>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme="cyan"
            variant="ghost"
            mr={3}
            onClick={() => {
              formik.resetForm()
              onClose()
            }}
          >
            Cancel
          </Button>
          <Button
            colorScheme="cyan"
            color="white"
            onClick={() => formik.handleSubmit()}
            isLoading={formik.isSubmitting || loading}
          >
            Deploy
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default ManualDeployModal
